

// Customize this 'myform.js' script and add it to your JS bundle.
// Then import it with 'import MyForm from "./myform.js"'.
// Finally, add a <MyForm/> element whereever you wish to display the form.

import React from "react";

export default class MyForm extends React.Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      status: ""
    };
  }

  render() {
    const { status } = this.state;
    return (    <div className="contact-container">
      <div className="contact-left">Om ni undrar något eller vill komma i kontakt med oss, tveka inte att höra av er.</div>
      <div className="contact-form">      <form className="contact-form text-center"
        onSubmit={this.submitForm}
        action="https://formspree.io/f/mdoprqaa"
        method="POST"
      >
        
        <label>Namn:</label>
        <input type="namn" name="namn" className="namn"/><br />
        <label>Email:</label>
        <input type="email" name="email" className="email"/><br />
        <label>Message:</label>
        <input type="text" name="message" className="text"/><br />
        {status === "SUCCESS" ? <p>Thanks!</p> : <button>Submit</button>}
        {status === "ERROR" && <p>Ooops! There was an error.</p>}
      </form></div>
    </div>

    );
  }

  
  submitForm(ev) {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        this.setState({ status: "SUCCESS" });
      } else {
        this.setState({ status: "ERROR" });
      }
    };
    xhr.send(data);
  }
}



   

